// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_fH-","delete":"styles_delete__2272o","update":"styles_update__2WdCO","add":"styles_add__1yP8g"};